import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        await axios.post(`${API_URL}/api/analytics/track`, {
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent
        });
      } catch (error) {
        // Silently fail - don't break the site if tracking fails
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location.pathname]);
};

export default usePageTracking;
